const formatTime = (seconds) => `${Math.floor(seconds / 60)}:${(seconds % 60).toFixed(0).toString().padStart(2, '0')}`;

// Time Slider
export const TimeSlider = ({ time, duration, accentColor, audioRef, mini }) => {
  const handleSliderKeyDown = (e) => {
    if (e.key === 'ArrowRight') {
      audioRef.current.currentTime = Math.min(audioRef.current.currentTime + 5, duration);
      e.preventDefault();
    } else if (e.key === 'ArrowLeft') {
      audioRef.current.currentTime = Math.max(audioRef.current.currentTime - 5, 0);
      e.preventDefault();
    }
  };
  return (
    <div
      className={`${mini ? 'col-span-2 col-start-2 row-start-4' : 'col-start-5 row-start-3'} relative col-span-2 h-px-2.5 w-full cursor-pointer rounded-full bg-gray-200`}
      onClick={(e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const percentage = (e.clientX - rect.left) / rect.width;
        audioRef.current.currentTime = percentage * duration;
      }}
      onKeyDown={handleSliderKeyDown}
      role="slider"
      aria-label="Seek time in track"
      aria-valuemin="0"
      aria-valuemax={duration.toString()}
      aria-valuenow={time.toString()}
      aria-valuetext={`${formatTime(time)} of ${formatTime(duration)}`}
      tabIndex="0"
      style={{ outline: 'none' }}
    >
      <div
        className="absolute top-0 left-0 h-px-2.5 rounded-full"
        style={{ width: `${(time / duration) * 100}%`, backgroundColor: accentColor }}
        aria-hidden="true"
      ></div>
    </div>
  );
};
